var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/components/info-menu/MenuItems.tsx",
  _this = this;
import React, { useContext } from 'react';
import { Typography } from '@wds/typography';
import { List } from '@wds/list';
import { Box } from '@wds/box';
import { Responsive } from '@wds/responsive';
import { generateMetricsAttribute } from '@sm/metrics';
import { SubMenuItem } from '../mobile-nav/SubMenuItem';
import useStyles from './useStyles';
import HeaderContext from '../../HeaderContext';
var MenuItems = function MenuItems(_ref) {
  var title = _ref.title,
    url = _ref.url,
    subTitle = _ref.subTitle,
    navItem = _ref.navItem,
    _ref$openInNewWindow = _ref.openInNewWindow,
    openInNewWindow = _ref$openInNewWindow === void 0 ? false : _ref$openInNewWindow;
  var classes = useStyles();
  var _useContext = useContext(HeaderContext),
    pageURL = _useContext.pageURL,
    pageName = _useContext.pageName;
  var metrics = generateMetricsAttribute({
    data: {
      url: pageURL,
      pageName: pageName,
      amplitudeEvent: 'header clicked navigation',
      navItem: navItem
    }
  });
  return /*#__PURE__*/React.createElement(Responsive, {
    minWidth: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 5
    }
  }, function (matches) {
    return matches ? /*#__PURE__*/React.createElement(List.Item, Object.assign({
      interactive: true,
      isNavigable: true,
      href: url,
      "data-sm-metrics": metrics
    }, openInNewWindow === true && {
      target: '_blank',
      rel: 'noopener noreferrer'
    }, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement(Box, {
      py: 4,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52,
        columnNumber: 15
      }
    }, title), /*#__PURE__*/React.createElement(Box, {
      pt: 1,
      display: "flex",
      className: classes.descriptionBox,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "bodySm",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 17
      }
    }, subTitle)))) : /*#__PURE__*/React.createElement(SubMenuItem, {
      title: title,
      url: url,
      metrics: metrics,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 11
      }
    });
  });
};
export default MenuItems;
export { MenuItems };
//# sourceMappingURL=MenuItems.js.map